import { render, staticRenderFns } from "./t-tag.vue?vue&type=template&id=2a8e5f26"
import script from "./t-tag.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-tag.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports